import { lens } from "@dhmk/zustand-lens";
import type { GetProjectBillingResponseBody } from "@imagine/ai-service/shared-types/route-types";

type BillingState = GetProjectBillingResponseBody & {};

type BillingActions = {
  setBilling: (billing: GetProjectBillingResponseBody) => void;
  reset: () => void;
};

export type BillingSlice = BillingState & BillingActions;

const defaultBillingState: BillingState = {
  creditsUsed: 0,
  dailyCreditsUsed: 0,
  allowedCredits: 0,
  allowedDailyCredits: undefined,
  hasExceededUsageLimit: false,
  isRunningLow: false,
};

export const billingSlice = lens<BillingSlice>((set) => ({
  ...defaultBillingState,
  setBilling: (billing) => set(billing),
  reset: () => set({ ...defaultBillingState }),
}));
